var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComposite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 3",
    id: "Layer_3",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63,26V22h-.009A.973.973,0,0,0,62,21H55.414l7.293-7.293A1,1,0,0,0,62,12H18a1,1,0,0,0-.707.293l-16,16A1,1,0,0,0,2,30H8.586L1.293,37.293A.991.991,0,0,0,1.009,38H1v4a1,1,0,0,0,1,1H8.586L1.293,50.293A1,1,0,0,0,2,52H46a1,1,0,0,0,.707-.293l16-16A1,1,0,0,0,62,34H55.414l7.293-7.293A1,1,0,0,0,63,26ZM18.414,14H59.586l-14,14H4.414Zm-7,16H46a1,1,0,0,0,.707-.293L53.414,23h6.172l-14,14H4.414ZM3,39H45v2H3Zm56.586-3-14,14H4.414l7-7H46a1,1,0,0,0,.707-.293L53.414,36ZM47,39.586V38.414l14-14v1.172Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposite);
export default __webpack_public_path__ + "static/media/composite.d66666e004c5f649b6e86d45c3950c6e.svg";
export { ForwardRef as ReactComponent };